import React, { useState, useEffect } from "react";
import { Pagination, Select } from "antd";
import MediaPlayers from "./MediaPlayer/MediaPlayer";
import "./VideoGuides.css";
import { useDispatch, useSelector } from "react-redux";
import { list_video_guide_ActionHandler } from "../../../Redux/Actions/user/createVideoGuide";
import { debounce } from "lodash";
import Loader from "../../../Components/Loader/Loader";

const SearchIcon = "/assets/SearchIcon.svg";
const itemsPerPage = 4;

const VideoGuides = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const videoData = useSelector(
    (state) => state.list_video_guide_data.list_video_guide_data.data
  );

  useEffect(() => {
    window.dataLayer.push({
      event: "Videos",
      buttonName: "Videos Guildlines",
      userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
      clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
    });
  }, []);

  useEffect(() => {
    const delayedSearch = debounce(() => {
      setLoading(true);
      dispatch(list_video_guide_ActionHandler(searchText));
      setLoading(false);
    }, 800);
    delayedSearch();

    return delayedSearch.cancel;
  }, [dispatch, searchText]);

  const data = [
    {
      id: "1",
      title: "Welcome to QuickAction",
      videoUrl:
        "https://quick-action-dev.s3.eu-west-2.amazonaws.com/dev/videos/1704968700_73816_test.mp4",
    },
  ];
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      {!loading && videoData ? (
        <div className="resources-tab-padding">
          <div className="resources-input-divv">
            <div className="relative search-container">
              <input
                value={searchText}
                created_by="text"
                placeholder="Search Videos here"
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                className="search-from-logs"
              />
              <img src={SearchIcon} alt="searchIcon" className="search-icon" />
            </div>
          </div>
          {videoData?.length > 0 ? (
            <div className="video-players-div">
              <MediaPlayers data={videoData} />
            </div>
          ) : (
            <div className="no-resource-text">
              <p>No resource found</p>
            </div>
          )}
          <div className="resources-pagination">
            <Pagination
              current={currentPage}
              onChange={handlePageChange}
              total={data?.length}
              pageSize={itemsPerPage}
            />
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default VideoGuides;
